// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/storage/v1/project_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchDeleteProjectRequest, BatchDeleteProjectResponse, CreateProjectRequest, CreateProjectResponse, DeleteProjectRequest, GetProjectRequest, GetProjectResponse, ListAllProjectsRequest, ListAllProjectsResponse, ListProjectEventsRequest, ListProjectEventsResponse, ListProjectsContainingExperimentRequest, ListProjectsContainingExperimentResponse, ListProjectSharingsRequest, ListProjectSharingsResponse, ListProjectsRequest, ListProjectsResponse, ShareProjectRequest, ShareProjectResponse, TransferProjectOwnershipRequest, TransferProjectOwnershipResponse, UnshareProjectRequest, UnshareProjectResponse, UpdateProjectRequest, UpdateProjectResponse } from "@buf/h2oai_mlops-storage.bufbuild_es/ai/h2o/mlops/storage/v1/project_service_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.storage.ProjectService
 */
export const ProjectService = {
  typeName: "ai.h2o.storage.ProjectService",
  methods: {
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.GetProject
     */
    getProject: {
      name: "GetProject",
      I: GetProjectRequest,
      O: GetProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.ListProjects
     */
    listProjects: {
      name: "ListProjects",
      I: ListProjectsRequest,
      O: ListProjectsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.ListProjectsContainingExperiment
     */
    listProjectsContainingExperiment: {
      name: "ListProjectsContainingExperiment",
      I: ListProjectsContainingExperimentRequest,
      O: ListProjectsContainingExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.ListAllProjects
     */
    listAllProjects: {
      name: "ListAllProjects",
      I: ListAllProjectsRequest,
      O: ListAllProjectsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.CreateProject
     */
    createProject: {
      name: "CreateProject",
      I: CreateProjectRequest,
      O: CreateProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.UpdateProject
     */
    updateProject: {
      name: "UpdateProject",
      I: UpdateProjectRequest,
      O: UpdateProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.DeleteProject
     */
    deleteProject: {
      name: "DeleteProject",
      I: DeleteProjectRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.BatchDeleteProject
     */
    batchDeleteProject: {
      name: "BatchDeleteProject",
      I: BatchDeleteProjectRequest,
      O: BatchDeleteProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.ShareProject
     */
    shareProject: {
      name: "ShareProject",
      I: ShareProjectRequest,
      O: ShareProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.UnshareProject
     */
    unshareProject: {
      name: "UnshareProject",
      I: UnshareProjectRequest,
      O: UnshareProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.ListProjectEvents
     */
    listProjectEvents: {
      name: "ListProjectEvents",
      I: ListProjectEventsRequest,
      O: ListProjectEventsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.ListProjectSharings
     */
    listProjectSharings: {
      name: "ListProjectSharings",
      I: ListProjectSharingsRequest,
      O: ListProjectSharingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ProjectService.TransferProjectOwnership
     */
    transferProjectOwnership: {
      name: "TransferProjectOwnership",
      I: TransferProjectOwnershipRequest,
      O: TransferProjectOwnershipResponse,
      kind: MethodKind.Unary,
    },
  }
};

